import type { MarkNotificationAsFailed200BasicInfo } from './markNotificationAsFailed200BasicInfo';
import type { MarkNotificationAsFailed200Data } from './markNotificationAsFailed200Data';
import type { MarkNotificationAsFailed200Source } from './markNotificationAsFailed200Source';
import type { MarkNotificationAsFailed200Status } from './markNotificationAsFailed200Status';
import type { MarkNotificationAsFailed200Target } from './markNotificationAsFailed200Target';

export type MarkNotificationAsFailed200 = {
  basicInfo: MarkNotificationAsFailed200BasicInfo;
  /** @nullable */
  data?: MarkNotificationAsFailed200Data;
  source?: MarkNotificationAsFailed200Source;
  status: MarkNotificationAsFailed200Status;
  target?: MarkNotificationAsFailed200Target;
};
